import type { MailboxInfo } from 'owa-client-types';
import {
    isMailboxSharedOrDelegateUserMailbox,
    isSharedCoprincipalAccountEnabled,
} from 'owa-account-shared-mailbox-utils';

export function isSharedOrDelegateMailbox(mailboxInfo: MailboxInfo): boolean {
    return isSharedCoprincipalAccountEnabled() && isMailboxSharedOrDelegateUserMailbox(mailboxInfo);
}
